export const colFormRef = 'col-form-login';
